import { ref } from '@vue/composition-api';

const connections = ref([]);
const isVideoDisabled = ref(false);
export default function useConnections() {
  function setDirection() {
    connections.value.forEach((connection) => {
      const transceivers = connection.value.getTransceivers();
      const videoTransceiver = transceivers.find((t) => t.mid === 'video');
      if (!isVideoDisabled.value) {
        videoTransceiver.direction = 'inactive';
      } else {
        videoTransceiver.direction = 'recvonly';
      }
    });
    isVideoDisabled.value = !isVideoDisabled.value;
  }

  function toggleVideo() {
    setDirection();
  }
  return {
    connections,
    toggleVideo,
    isVideoDisabled,
  };
}
